import { inject, Injectable } from '@angular/core';
import { API_URLS, WebServiceProvider } from '@pinnakl/core/web-services';
import {
  TradeWorkflowSpec,
  TradeWorkflowSpecApi,
  TradeWorkflowSpecUpdateParams,
} from '@pinnakl/poems/trade-workflow-spec/domain';
import { PinnaklUIToastMessage } from '@pinnakl/shared/util-providers';

type UpdateTradeWorkflowSpec = TradeWorkflowSpecUpdateParams & Pick<TradeWorkflowSpec, 'id'>;

@Injectable({
  providedIn: 'root',
})
export class TradeWorkflowSpecApiService {
  private readonly wsp = inject(WebServiceProvider);
  private readonly apiUrls = inject(API_URLS);
  private readonly toast = inject(PinnaklUIToastMessage);

  async getTradeWorkflowSpec(): Promise<TradeWorkflowSpec> {
    const values = await this.wsp.get<TradeWorkflowSpecApi[]>({ endpoint: this.apiUrls.omsConfigV3 });
    if (values.length === 0) {
      this.toast.error('No trade workflow spec found');
      throw new Error('No trade workflow spec found');
    }
    return values[0];
  }

  updateTradeWorkflowSpec(tradeWorkflowSpec: UpdateTradeWorkflowSpec): Promise<TradeWorkflowSpec> {
    return this.wsp.put<TradeWorkflowSpec>({
      endpoint: this.apiUrls.omsConfigV3,
      payload: tradeWorkflowSpec,
    });
  }

  createTradeWorkflowSpec(tradeWorkflowSpec: Partial<TradeWorkflowSpec>): Promise<TradeWorkflowSpec> {
    return this.wsp.post<TradeWorkflowSpec>({
      endpoint: this.apiUrls.omsConfigV3,
      payload: tradeWorkflowSpec,
    });
  }
}
